<template>
    <div id="bene-bill-payment-bill-corp-container">
        <f7-list form class="form-group" v-if="showFormSet.billPayment">
            <f7-list-input
                input-id     ="billCorp"
                name         ="billCorp"
                type         ="text"

                :label       ="$t('beneficiary-bill-corp')"
                :placeholder ="$t('beneficiary-enter-bill-corp')"
                :value       ="billCorporationName"
                @change      ="changeBillCorp($event.target.value); validateInput($event.target); setInput('billCorp')"

                autocomplete="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { debounce } from 'lodash'; 
    export default {
        props: {
        },
        mounted() {
            // this.loadBillCorpList();
            this.renderBillCorpAutocomplete();
        },
        data: function() {
            return {
                billCorpList : [],
            }
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'billCorporationId',
                'billCorporationList',
                'billCorporationName',
                'showPreloaderState'
            ]),
        },
        on: {
            pageBeforeRemove() {
                const self = this;
                // Destroy all autocompletes
                self.autocompleteBillCorpDropdownSimple.destroy();
            },
        },
        methods: {
            ...mapActions('beneficiary', [
                'setBillCorp',
                'setBillCorporationList',
                'setShowPreloaderState',
            ]),

            changeBillCorp(name) {
                this.setShowPreloaderState({name: "billCorp", value: true});
                this.showPreloader();
                this.$emit("changeBillCorp", name);
                if(this.showPreloaderState.name == "billCorp" && this.showPreloaderState.value) {
                    this.hidePreloader();
                }
            },

            validateInput(inputEl) {
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl) {
                this.$emit("setInput", inputEl);
            },

            renderBillCorpAutocomplete(){
                const self         = this;
                const app          = self.$f7;

                //console.log("NEW LIST : ", self.billCorpList)

                // Simple Dropdown
                self.autocompleteBillCorpDropdownSimple = app.autocomplete.create({
                    inputEl: '#billCorp',
                    openIn : 'dropdown',
                    class  : '',
                    source : function(query, render) {

                        const debouncedFetchData = debounce(function () {
                            if(query.length >= 3) {
                                self.$api.beneficiary.getBillCorporationListByName(query).then( response => {
                                let result = [];
                                let filteredList = [];
                                                                
                                // Find Matched Items
                                response.forEach(function(item){
                                    if(item.name.toLowerCase().indexOf(query.toLowerCase()) >= 0){
                                        result.push(item.name);
                                        filteredList.push(item);
                                    }
                                });

                                self.billCorpList = result;
                                self.setBillCorporationList(filteredList);
                                render(result.sort());
                                return;

                                });
                            }else{
                                render([]);
                                return;
                            }
                        }, 500);

                        debouncedFetchData();
                    }
                })
            },


            loadBillCorpList() {
                const self         = this;
                const app          = self.$f7;
                const billCorpList = self.billCorporationList;

                // Simple Dropdown
                self.autocompleteBillCorpDropdownSimple = app.autocomplete.create({
                    inputEl: '#billCorp',
                    openIn : 'dropdown',
                    class  : '',
                    source : function(query, render) {
                        const results = [];
                        if(query.length <= 2) { // Need to enter min 3 chars
                            return;
                        }
                        if(query.length === 0) {
                            render(results);
                            return;
                        }
                        // Find Matched Items
                        Object.keys(billCorpList).forEach(key => {
                            if(billCorpList[key].toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                                results.push(billCorpList[key]);
                            }
                        })

                        // Render Items By Passing Array With Result Items
                        render(results.sort());
                    }
                })
            }
        }
    }
</script>